<script setup lang="ts">
import UProductContributorsSimple from "./UProductContributorsSimple.vue"

const productContent = useProductContentStore()
const shouldDisplayContributor = computed(() => productContent.articles[0]?.id !== productContent.activeArticle?.id)
</script>

<template>
	<footer class="flex flex-col gap-3 pb-28 md:pb-32 order-4">
		<UProductContributorsSimple v-if="shouldDisplayContributor" />
    <UCite />
	</footer>
</template>
